import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

// read by public/index.html too, to load the HPE header in the same scheme
const STORAGE_KEY = "theme-mode";

const getInitialMode = () => (window.localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light");

const ThemeModeContext = createContext({ themeMode: "light", toggleThemeMode: () => { } });

export const ThemeModeProvider = ({ children }) => {
    const [themeMode] = useState(getInitialMode);

    // the HPE header script can't restyle after load, so reload to keep it in sync with the app
    const toggleThemeMode = useCallback(() => {
        window.localStorage.setItem(STORAGE_KEY, themeMode === "dark" ? "light" : "dark");
        window.location.reload();
    }, [themeMode]);

    const value = useMemo(() => ({ themeMode, toggleThemeMode }), [themeMode, toggleThemeMode]);

    return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};

export const useThemeMode = () => useContext(ThemeModeContext);
